import { useRef } from 'react';

export const useAnimation = (element: React.RefObject<HTMLDivElement>) => {
  const requestAnimationFrameRef = useRef<number[]>([]);

  const stopAnimation = (...args: string[][]) => {
    if (!element.current) return;
    requestAnimationFrameRef.current.forEach((id) => window.cancelAnimationFrame(id));
    args.forEach((classList) => element.current!.classList.remove(...classList));
    requestAnimationFrameRef.current = [];
  };

  const runAnimation = (...args: string[][]) => {
    if (!element.current) return;
    args.forEach((classList) => {
      const animationFrameId = window.requestAnimationFrame(() => {
        if (!element.current) return;
        element.current.classList.add(...classList);
      });
      requestAnimationFrameRef.current.push(animationFrameId);
    });
  };

  return { stopAnimation, runAnimation };
};
